import HypothesisHoverCard from "./HypothesisHoverCard";

export default function RunHypothesisHoverCard({
  ticker,
  hypothesis,
}: {
  ticker: string;
  hypothesis: string;
}) {
  return (
    <HypothesisHoverCard
      label={`View ${ticker} modeling hypothesis`}
      eyebrow={`${ticker} · Modeling hypothesis`}
      hypothesis={hypothesis}
    />
  );
}
